var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackgroundGenial(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 295.99 116.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b7c910;}.cls-2{fill:#eacd00;}.cls-3{fill:#ff4e00;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 1laptop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.55,32.45a4.81,4.81,0,1,1-3.91-5.56,4.81,4.81,0,0,1,3.91,5.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M224.91,104.56A4.81,4.81,0,1,1,221,99a4.82,4.82,0,0,1,3.91,5.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M295.94,24a3.23,3.23,0,1,1-2.62-3.74A3.23,3.23,0,0,1,295.94,24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M141.41,3.79A3.23,3.23,0,1,1,138.78.05a3.22,3.22,0,0,1,2.63,3.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.66,112.75a3.43,3.43,0,1,1-3.42-3.43,3.42,3.42,0,0,1,3.42,3.43"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundGenial);
export default __webpack_public_path__ + "static/media/background-genial.434aa6a96e81f6b55660bcb0cb5e230f.svg";
export { ForwardRef as ReactComponent };